import api from '@/services/utils/apiInstance.ts';
import { displayNonNotFoundError } from '@/utils/apiErrorUtils.ts';

import type { CustomAxiosRequestConfig } from '@/types/services/utils/axios.type.ts';
import type { InvestorForm, InvestorFormResponseApi } from '@/types/services/user/investorForm.type.ts';

class InvestorFormService {
  // Returns `null` if the client hasn't filled in the investor questionnaire yet (404, format B).
  // Only the latest submitted questionnaire is returned by the API, no history.
  async getInvestorForm(userId: number): Promise<InvestorForm | null> {
    try {
      const response = await api.get(
        `/user-form/bo/${userId}`,
        { disableGlobalError: true } as CustomAxiosRequestConfig
      )
      const d: InvestorFormResponseApi = response.data

      return {
        scoreTotal: d.score_total,
        profileType: d.profile_type,
        nextAllowedDate: d.next_allowed_date,
        answers: (d.answers ?? []).map(a => ({
          question: a.question,
          answer: a.answer,
          category: a.category,
          weightedContribution: a.weighted_contribution,
          weight: a.weight
        }))
      }
    } catch (error) {
      displayNonNotFoundError(error)
      return null
    }
  }
}

export default new InvestorFormService();
